<template>
  <div class="top_box">
    <div class="top_content">
      <el-tabs
        style="height: 50px"
        class="top_content"
        :value="pagePath"
        :stretch="true"
        :closable="false"
        @tab-click="handleClick">
        <el-tab-pane
          v-for="page in aside"
          :key="page.path"
          :label="page.title || '未命名'"
          :name="page.path"/>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import util from "@/libs/util.js"
  export default {
    data() {
      return {
        pagePath:'',
        activeName: ''
      };
    },
    computed: {
      ...mapState('d2admin/menu',
        ['aside']
      ),
      ...mapState('d2admin/page', [
        'current',
      ])
    },
    watch:{
      current(newValue,oldValue){
        let pathArr =newValue.split('/');
        if(pathArr.length == 2||pathArr[2] == 'workbenchInfo'){
          if(pathArr[1] == 'transport'){
            this.pagePath = '/'+pathArr[1]+'/'+'workbench'
          }else{
            this.pagePath = '/'+pathArr[1]
          }
          if(pathArr[1] == 'container'){
            this.pagePath = '/'+pathArr[1]+'/'+'containerPreOrder'
          }else{
            this.pagePath = '/'+pathArr[1]
          }
        }else{
          if(pathArr[2] == 'customerCommunication'||pathArr[2] =="listQuery"){
            this.pagePath = '/'+pathArr[1]
          }else if(newValue == '/commerce/'){
            this.pagePath = '/'+pathArr[1]
          }else{
            this.pagePath = '/'+pathArr[1]+'/'+pathArr[2]
          }

        }
        util.cookies.set('pagePath',this.pagePath)
        // util.cookies.set('redirect', this.pagePath)
      }
    },
    mounted(){
      this.pagePath = util.cookies.get('pagePath')
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClick(tab, event) {
        this.$router.push(tab.name)
      },
    }
  }
</script>

<style lang="scss">
  .top_box {
    border-bottom: 1px solid #E0E0E0;
    background: $color-text-sub;
    .top_content {
      width: $containerWidth;
      margin: 0 auto;

      .el-tabs__active-bar {
        height: 0;
      }
      .el-tabs__item {
        height: 50px;
        line-height: 50px;
      }
      .el-tabs__nav-wrap::after {
        background: transparent;
      }
    }
  }
</style>
